import { pipe } from 'fp-ts/lib/function';
import { useEffect, useMemo, useRef } from 'react';
import { groupByAprBNPL, GroupedByApr } from 'utils';
import { useFinanceCalculatorContext } from '../../context';
import { PLACEHOLDER_GROUPED } from './constant';

export interface APRsHook {
  isLoading: boolean;
  workTypeSelected: boolean;
  grouped?: GroupedByApr;
  keys: string[];
}

export default function useAPRs(): APRsHook {
  const { isLoading, rates, onSelectAPR, workType } =
    useFinanceCalculatorContext();

  const workTypeSelected = useMemo(() => Boolean(workType), [workType]);

  const grouped = useMemo(() => {
    if (isLoading) return PLACEHOLDER_GROUPED;
    if (!rates) return undefined;
    return pipe(rates, groupByAprBNPL);
  }, [isLoading, rates]);

  const keys = useMemo(() => {
    if (!grouped) return [];
    return Object.keys(grouped);
  }, [grouped]);

  const initRef = useRef<boolean>(false);
  useEffect(() => {
    if (isLoading || initRef.current || keys.length === 0) return;
    initRef.current = true;
    onSelectAPR(keys[0]);
  }, [isLoading, keys, onSelectAPR]);

  return {
    isLoading,
    workTypeSelected,
    grouped,
    keys,
  };
}
